import { Link } from "react-router-dom";
import portalOneLogo from "@/assets/portalone-suite-logo.png";

interface FooterProps {
  logo?: string;
  logoAlt?: string;
}

export function Footer({ logo = portalOneLogo, logoAlt = "PortalONE Suite" }: FooterProps = {}) {
  return (
    <footer className="border-t border-border bg-muted/30 transition-colors duration-300">
      <div className="mx-auto max-w-7xl px-4 py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo à esquerda */}
          <div className="flex-shrink-0">
            <Link to="/" className="cursor-pointer">
              <img src={logo} alt={logoAlt} className="h-[60px] md:h-[70px] w-auto rounded-sm object-contain" />
            </Link>
          </div>

          {/* Copyright centralizado */}
          <div className="flex-1 text-center">
            <span className="text-xs md:text-sm text-muted-foreground">
              © {new Date().getFullYear()} — Todos os direitos reservados.
            </span>
          </div>

          {/* Links à direita */}
          <div className="flex gap-6 text-sm text-muted-foreground flex-shrink-0">
            <Link to="/legal/terms" className="hover:text-foreground transition-colors whitespace-nowrap">Termos</Link>
            <Link to="/legal/privacy" className="hover:text-foreground transition-colors whitespace-nowrap">Privacidade</Link>
            <Link to="/status" className="hover:text-foreground transition-colors whitespace-nowrap">Status</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}